import { FormInputTypes, GridColSpan, TypedFormInputs } from 'components/form';
import {
  acceptImages,
  acceptPdf,
  dropzoneValidation,
} from 'components/dropzone/utils';
import {
  EditFormSubmissionDocumentFormData,
  EditableJobsiteFormSubmissionDocument,
} from './types';

export const getFormInputs =
  (): TypedFormInputs<EditFormSubmissionDocumentFormData> => ({
    file: {
      element: FormInputTypes.Dropzone,
      label: 'Attachment',
      layout: GridColSpan.SpanFull,
      elementProps: {
        accept: {
          ...acceptPdf,
          ...acceptImages,
        },
      },
      validation: {
        required: true,
        validate: dropzoneValidation,
      },
    },
    description: {
      element: FormInputTypes.Field,
      label: 'Description',
      layout: GridColSpan.SpanFull,
      validation: { required: true },
    },
  });

export const getDefaultValues = (
  document?: EditableJobsiteFormSubmissionDocument,
): EditFormSubmissionDocumentFormData => {
  const { files, description } = document ?? {};
  return {
    file: files?.[0] ?? null,
    description: description ?? '',
  };
};
